<template>
  <v-row class="justify-center">
    <v-col cols="12" md="4" sm="12" xs="12" class="pt-5" style="min-width: 420px">
      <pricing-item
        name="Digital Asset Discovery"
        :message="'30 day trial'"
        :list="freeTierList"
        price="$350"
        footer="Free 30 Day Trial"
        :plan="'Cloud'"
      />
    </v-col>
    <v-col cols="12" md="4" sm="12" xs="12" class="pt-5" style="min-width: 420px">
      <pricing-item
        name="Digital Risk Severity"
        price="$1750"
        message="Paid"
        :list="standardTierList"
        :plan="'Cloud+'"
        footer="Upgrade Now"
      />
    </v-col>
    <!-- <v-col md="4" sm="6" xs="12">
      <pricing-item
        name="Edge"
        phone="+1 (855) 438-6946"
        price="Contact us"
        message="Your digital risk in realtime"
        :list="enterpriseTierList"
        :selected="selected === 'Edge'"
        footer="Contact Sales"
      />
    </v-col> -->
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import PricingItem from './PricingItem.vue'
export default {
  name: 'PricingList',
  components: {
    'pricing-item': PricingItem
  },
  computed: {
    ...mapGetters(['user', 'paymentInformation'])
  },
  data () {
    return {
      freeTierList: ['Digital asset segmentation', 'Digital Asset Inventory', 'Retention analysis', 'Unstructured digital assets'],
      standardTierList: ['Regulatory regime classification', 'Dollarized risk ranges', 'Data redundancy', 'Unstructured digital assets', 'Structured digital assets'],
      enterpriseTierList: ['Unlimited File Store Connections', 'Digital Asset Inventory', 'Retention Analysis and Management', 'Regulatory Analysis', 'Redundancy Analysis', 'Digital Risk Analysis', 'Edge Analysis', 'Datastores: Unstructured', 'Volume: GBs to TBs ']
    }
  }
}
</script>

<style scoped>

</style>
